// =============================================================================
// src/rules/legal-sources.js  —  shared "what can act this turn" (GetSources)
// -----------------------------------------------------------------------------
// SHARED RULES (client + server) — see src/rules/random.js for usage/bundling.
// This is the anti-cheat surface: the server recomputes legal sources and never
// trusts the client's word. Self-contained.
//
// Strict-mode note: `temp` is now a real local variable (it used to be an
// accidental global in the old non-strict file).
// =============================================================================

/**
 * Which sources the active player (player1) may use right now:
 * spot-code -> boolean (true = usable).
 * @param {object} duel
 * @param {true|string} [Entry]  true = everything, or narrow to "Board_"/"Card_".
 * @returns {Object<string,boolean>}
 */
export function GetSources(duel, Entry = true) {
	console.log("GetSources:" + Entry);
	if (duel.player1.tick == 0) {
		return {};
	}
	var temp = {};
	if (Entry === true || Entry.includes("Board_")) {
		for (var i = 0; i < 4; i++) {
			for (var o = 0; o < 4; o++) {
				temp["Board_" + i + "_" + o] = false;
				if (duel.board[i][o] != false) {
					if (i >= 2 || duel.board[i][o].health <= 0) {
						temp["Devour"] = true;
					}
					if (i >= 2 && duel.board[i][o].ready && !duel.board[i][o].keywords.guardian) {
						temp["Board_" + i + "_" + o] = true;
					}
				}
			}
		}
	}
	if (duel.player2.deck == 0) {
		temp["Devour"] = true;
	}
	if (Entry === true || Entry.includes("Card_")) {
		duel.player1.hand.forEach((card, index) => {
			var discount = duel.player1.static["Discount"] || 0;
			var realCropCost = Math.max(card.cropCost - discount, 0);
			var realMeatCost = Math.max(card.meatCost - discount, 0);
			if (card.name == "Bite Back" && !duel.player2.biter) {
				return;
			}
			if (card.tags.includes("Early") && duel.player1.tookAction) {
				return;
			}
			//Full Moon
			if (card.id == 104 && !duel.board
				.slice(-2)
				.some((row) => row.some((item) => item?.tags?.includes("Canine")))) {
				return;
			}
			if (card.id == 103) {//Lone Wolf
				if (
					duel.board
						.slice(-2)
						.every((row) => row.every((item) => !item))
				) {
					realMeatCost = Math.max(0, realMeatCost - 4);
				}
			}
			if (realCropCost <= duel.player1.crop && realMeatCost <= duel.player1.meat) {
				if (card.moreCost) {
					//More Cost Calculations
				}
				if ((!card.extraTickCost || card.extraTickCost < duel.player1.tick)) {
					temp["Card_" + index] = true;
				}
			}
		});
	}
	return temp;
}
